import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Validators from './validators'
import { BaseManipStateFn, BaseTableState } from './base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    prepareNew () {
      if (store.loggedUser) {
        this.record.set('user', store.loggedUser.email)
      }
    }

    onSaved (saved) {
      store.markDirty('timeRestrictions')
      super.onSaved(saved)
    }

    createtitle = store.__(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    validators = {
      date: [
        Validators.isMandatory(store)
      ],
      _global: (vals, errors) => {
        if (!vals.get('id') && vals.has('date') && vals.get('date')) {
          if (moment(vals.get('date')).format(defaultConst.DATE_FORMAT) !== moment(vals.get('date')).endOf('month').format(defaultConst.DATE_FORMAT)) {
            return [store.__('The inserted date is not the last day of the month.')]
          }
        }
      }
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'user', 'date'
    ]

    headertitles = [
      store.__('ID'), store.__('user'), store.__('date')
    ]

    title = store.__(linkConst.LINK_CONTRACT_TIME_RESTRICTIONS_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_CONTRACT_TIME_RESTRICTIONS]
  }

  return { ManipState, TableState }
}
